<template>
    <div class="projects-container" id="portfolio">
    <div class="projects-text-wrapper">
      <div
        ref="projectsText"
        class="projects-text"
        :style="{ transform: `translateX(${translateX}px)` }"
      >
        <span
          v-for="(letter, index) in letters"
          :key="index"
          class="letter"
          :style="{ opacity: getLetterOpacity(index) }"
        >
          {{ letter === " " ? "\u00A0" : letter }}
        </span>
      </div>
    </div>

    <div class="cards-container" v-gsap-fade-up="{ offset: 40, duration: 0.9 }">
      <ProjectCard
        :header="$t('projects.cards.drainer.header')"
        :description="$t('projects.cards.drainer.description')"
        :badges="[
          'UI/UX',
          'Crypto',
          'Analytic',
          'Development',
        ]"
        imageSrc="@/assets/drainer.png"
      />

      <ProjectCard
        :header="$t('projects.cards.telegramPhish.header')"
        :description="$t('projects.cards.telegramPhish.description')"
        :badges="[
          'UI/UX',
          'Web App',
          'Development',
        ]"
        imageSrc="@/assets/phish.png"
      />

      <ProjectCard
        :header="$t('projects.cards.multiParser.header')"
        :description="$t('projects.cards.multiParser.description')"
        :badges="[
          'Parser',
          'Automatization',
          'Development',
          'CRM',
        ]"
        imageSrc="@/assets/parser.png"
      />
    </div>
    </div>
  </template>
  
  <script>
import ProjectCard from "../elements/ProjectCard.vue";
  export default {
    name: "ProjectsBlock",
  components: {
    ProjectCard,
  },
  data() {
    return {
      scrollProgress: 0,
      maxOffset: 0,
      translateX: 0,
      initialTextLeft: 0,
    };
  },
  computed: {
    text() {
      return this.$t("projects.title");
    },
    letters() {
      return this.text.split("");
    },
  },
  mounted() {
    this.calculateMaxOffset();
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    "$i18n.locale"() {
      this.$nextTick(() => {
        this.calculateMaxOffset();
      });
    },
  },
  methods: {
    calculateMaxOffset() {
      this.$nextTick(() => {
        if (!this.$refs.projectsText) return;

        const textElement = this.$refs.projectsText;
        const textWidth = textElement.scrollWidth;

        // Если это первый вызов (translateX = 0), сохраняем начальную позицию
        if (this.translateX === 0) {
          const textRect = textElement.getBoundingClientRect();
          this.initialTextLeft = textRect.left;
        }

        // Вычисляем, где заканчивается текст в начальной позиции относительно экрана
        const textEndPosition = this.initialTextLeft + textWidth;

        // Уменьшаем смещение, чтобы текст уезжал не так далеко (например, на 60% от полного смещения)
        this.maxOffset = Math.max(0, textEndPosition * 0.6);
      });
    },
    handleResize() {
      this.calculateMaxOffset();
      this.handleScroll();
    },
    handleScroll() {
      if (!this.$refs.projectsText) return;

      const element = this.$refs.projectsText;
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const elementTop = rect.top;
      const elementHeight = rect.height;

      // Анимация начинается только когда элемент виден хотя бы наполовину
      // scrollStart = когда элемент виден на 50% (нижняя половина элемента внизу экрана)
      const scrollStart = windowHeight - elementHeight / 1.2;
      const scrollEnd = -elementHeight;
      const scrollRange = scrollStart - scrollEnd;

      if (elementTop < scrollStart && elementTop > scrollEnd) {
        this.scrollProgress = (scrollStart - elementTop) / scrollRange;
        this.scrollProgress = Math.max(0, Math.min(1, this.scrollProgress));
      } else if (elementTop <= scrollEnd) {
        this.scrollProgress = 1;
      } else {
        this.scrollProgress = 0;
      }

      // Движение влево: от 0 до -maxOffset
      this.translateX = -this.maxOffset * this.scrollProgress;
    },
    getLetterOpacity(index) {
      // Каждая буква начинает становиться видимой последовательно слева направо
      // Начальная opacity 0.5, конечная 1.0
      const totalLetters = this.letters.length;
      const letterStart = index / totalLetters; // когда буква начинает становиться видимой
      const letterEnd = (index + 1) / totalLetters; // когда буква полностью видима

      if (this.scrollProgress <= letterStart) {
        return 0.5; // еще не началась анимация для этой буквы
      } else if (this.scrollProgress >= letterEnd) {
        return 1.0; // буква полностью видима
      } else {
        // Интерполяция между 0.5 и 1.0
        const letterProgress =
          (this.scrollProgress - letterStart) / (letterEnd - letterStart);
        return 0.5 + 0.5 * letterProgress;
      }
    },
  },
  };
  </script>
  
  <style scoped>
.projects-container {
  width: 100%;
  padding-left: 13%;
  padding-right: 13%;
  box-sizing: border-box;
}

.projects-text-wrapper {
  width: 100vw;
  max-width: 100vw;
  position: relative;
  overflow-x: hidden;
  overflow-y: visible;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  padding-left: 0;
  padding-right: 0;
  box-sizing: border-box;
}

.projects-text {
  font-size: clamp(152px, 19.79vw, 380px);
  letter-spacing: 0;
  overflow: visible;
  transition: transform 0.1s ease-out;
  white-space: nowrap;
  width: fit-content;
}

.letter {
  display: inline-block;
  transition: opacity 0.1s ease-out;
}

.cards-container {
  display: flex;
  flex-direction: column;
  gap: clamp(16px, 2vw, 32px);
  width: 100%;
  box-sizing: border-box;
}

@media screen and (max-width: 768px) {
  .projects-container {
    padding-left: 5%;
    padding-right: 5%;
  }
}
  </style>
  
